export type { AnimationData as CarnivalTreasureAnimationData } from './AnimationData';
export { BetType as CarnivalTreasureBetType } from './BetType';
export type { Record as CarnivalTreasureRecord } from './Record';
export type {
    OwnResult as CarnivalTreasureOwnResult,
    Result as CarnivalTreasureResult,
} from './Result';
export type { Statistics as CarnivalTreasureStatistics } from './Statistics';
export type { TotalBet as CarnivalTreasureTotalBet } from './TotalBet';
